import React,{ Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardBody, CardHeader} from "reactstrap";
import { getImages } from "../../../actions/actionImage";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import ReactJson from 'react-json-view';
import { bytesToSize } from "../../../utils/helpers"

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Images",path:"/images",isActive: false},
    {name: "ViewImages",path:"/viewimage",isActive: true},
];

class ViewImage extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentImage: null,
            userId: null
        };
    }

    componentDidMount(){
        this.props.getImages();
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.images.length > 0){
            let currentImage = nextProps.images.find(image => image.image_id === this.props.match.params.id);
            this.setState({currentImage: currentImage});
        }
    }


    render(){
        const {currentImage} = this.state;
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>View Image</strong>
                                {currentImage ? <Link className="pull-right" to={{ pathname: `/updateimage/${currentImage.image_id}`}}> 
                                    <Button size="sm" color="dark"> Edit Image </Button> </Link> : " " }
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                        <div>
                                            {currentImage?
                                                <Table bordered>
                                                    <tbody>
                                                        <tr><td>Image Id</td><td>{currentImage.image_id}</td></tr>
                                                        <tr><td>Name</td><td>{currentImage.name}</td></tr>
                                                        <tr><td>Description</td><td>{currentImage.description}</td></tr>
                                                        <tr><td>Friendly Name</td><td>{currentImage.friendly_name}</td></tr>
                                                        <tr><td>Thumbnail URL</td><td>{currentImage.image_src}</td></tr>
                                                        <tr><td>Cores</td><td>{currentImage.cores}</td></tr>
                                                        <tr><td>Friendly Name</td><td>{currentImage.friendly_name}</td></tr>
                                                        <tr><td>Memory</td><td>{bytesToSize(currentImage.memory)}</td></tr>
                                                        <tr><td>Enabled</td><td>{currentImage.enabled?"true":"false"}</td></tr>
                                                        <tr><td>Docker Registry</td><td>{currentImage.docker_registry}</td></tr>
                                                        <tr><td>Docker Registry Username</td><td>{currentImage.docker_user}</td></tr>
                                                        <tr><td>Docker Registry Password</td><td>{currentImage.docker_token}</td></tr>
                                                        <tr><td>Hash</td><td>{currentImage.hash}</td></tr>
                                                        <tr><td>Persistent Profile Path</td><td>{currentImage.persistent_profile_path}</td></tr>
                                                        <tr><td>Volume Mappings</td><td className="word-wrap"><ReactJson src={currentImage.volume_mappings}
                                                            name={false}
                                                            collapsed={false}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Run Config</td><td className="word-wrap"><ReactJson src={currentImage.run_config}
                                                            name={false}
                                                            collapsed={false}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Exec Config</td><td className="word-wrap"><ReactJson src={currentImage.exec_config}
                                                            name={false}
                                                            collapsed={false}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Restrict Image to Docker Network</td><td>{currentImage.restrict_to_network?"true":"false"}</td></tr>
                                                        <tr><td>Custom Network Name</td><td>{currentImage.network_name?currentImage.network_name:"NA"}</td></tr>
                                                        <tr><td>Restrict Image to Kasm Agent</td><td>{currentImage.restrict_to_server?"true":"false"}</td></tr>
                                                        <tr><td>Kasm Agent</td><td>{currentImage.server_id?currentImage.server_id:"NA"}</td></tr>
                                                    </tbody>                             
                                                </Table>   :" "} 
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewImage.propTypes = {
    getImages: Proptypes.func.isRequired,
    images: Proptypes.array,
    match: Proptypes.object
};

export default connect(state => 
    ({
        images: state.images.images || []
    }),
dispatch => 
    ({  
        getImages: () => dispatch(getImages())
    }))(ViewImage);


// WEBPACK FOOTER //
// ./src/views/Images/ViewImage/ViewImage.js